import React from "react";
import styled from "styled-components";
import BaseComponent from "../BaseComponent";
import { Image, Icon } from "semantic-ui-react";
import dateTimeHelper from "../../util/dateTimeHelper";
import CheckActive from "../../assets/check-active.png";
import CheckInactive from "../../assets/check-inactive.png";
import CheckYellow from "../../assets/check-yellow.png";

const TestResultWrapper = styled.div`
  width: 100%;
  border: solid 1px #f7f7f7;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 18px;
  padding-bottom: 18px;
  border-radius: 10px;
  flex-direction: row;
  margin-bottom: 6px;
  margin-top: 0px;
  margin-left: 21px;
  margin-right: 21px;
  cursor: pointer;
  background-color: white;
`;

const LeftPanel = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`;

const RightPanel = styled.div``;

const DiseaseAndDate = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
`;

const TestingCompanyAndTestType = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 10px;
`;

const DiseaseName = styled.div`
  color: black;
  font-weight: bold;
  display: inline;
`;

const DetailLeft = styled.div`
  color: black;
  display: inline;
`;

const DetailRight = styled.div`
  color: black;
  display: inline;
  text-align: right;
`;

class TestResult extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {};

    this.validDate = this.validDate.bind(this);
  }

  validDate(dateValue) {
    return dateValue != null && new Date(dateValue) > new Date();
  }

  render() {
    return (
      <TestResultWrapper>
        <LeftPanel>
          {this.props.item.valid === 0 ? (
            <Icon
              height={40}
              width={40}
              size="large"
              name={this.props.item.disputeStatus === 1 ? "exclamation" : "ban"}
              color="red"
            />
          ) : (
            <Image
              src={
                this.validDate(this.props.item.strongSafetyDate)
                  ? CheckActive
                  : this.validDate(this.props.item.weakSafetyDate)
                  ? CheckYellow
                  : CheckInactive
              }
              height={32}
              width={32}
            />
          )}
          <DiseaseAndDate>
            <DiseaseName>{this.props.item.diseaseName}</DiseaseName>
            <DetailLeft>
              {dateTimeHelper.formatDate(this.props.item.testDate)}
            </DetailLeft>
          </DiseaseAndDate>
        </LeftPanel>
        <RightPanel>
          <TestingCompanyAndTestType>
            <DetailRight>{this.props.item.testingCompanyName}</DetailRight>
            <DetailRight>
              {this.props.item.publicName +
                " (" +
                this.props.item.testName +
                ")"}
            </DetailRight>
          </TestingCompanyAndTestType>
        </RightPanel>
      </TestResultWrapper>
    );
  }
}

export default TestResult;
